// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function amount_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var amount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict._0, "amount"), null));
  if (amount.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              amount: amount._0
            }
          };
  }
  var e = amount._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".amount" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function online_payment_breakup_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var cashback = amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cashback"), null));
  if (cashback.TAG === /* Ok */0) {
    var porter_credits = amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "porter_credits"), null));
    if (porter_credits.TAG === /* Ok */0) {
      var paytm = amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paytm"), null));
      if (paytm.TAG === /* Ok */0) {
        var instamojo = amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "instamojo"), null));
        if (instamojo.TAG === /* Ok */0) {
          var razorpay = amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "razorpay"), null));
          if (razorpay.TAG === /* Ok */0) {
            var business_account = amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "business_account"), null));
            if (business_account.TAG === /* Ok */0) {
              var muneemji = amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "muneemji"), null));
              if (muneemji.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          cashback: cashback._0,
                          porter_credits: porter_credits._0,
                          paytm: paytm._0,
                          instamojo: instamojo._0,
                          razorpay: razorpay._0,
                          business_account: business_account._0,
                          muneemji: muneemji._0
                        }
                      };
              }
              var e = muneemji._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".muneemji" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = business_account._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".business_account" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = razorpay._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".razorpay" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = instamojo._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".instamojo" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = paytm._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".paytm" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = porter_credits._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".porter_credits" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = cashback._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".cashback" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function online_payment_details_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var amount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "amount"), null));
  if (amount.TAG === /* Ok */0) {
    var breakup_details = online_payment_breakup_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "breakup_details"), null));
    if (breakup_details.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                amount: amount._0,
                breakup_details: breakup_details._0
              }
            };
    }
    var e = breakup_details._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".breakup_details" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = amount._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".amount" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function breakup_details_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var online_payment_details = online_payment_details_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "online_payment_details"), null));
  if (online_payment_details.TAG === /* Ok */0) {
    var actual_driver_collected_cash = amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "actual_driver_collected_cash"), null));
    if (actual_driver_collected_cash.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                online_payment_details: online_payment_details._0,
                actual_driver_collected_cash: actual_driver_collected_cash._0
              }
            };
    }
    var e = actual_driver_collected_cash._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".actual_driver_collected_cash" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = online_payment_details._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".online_payment_details" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function pricing_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var lower_km = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "lower_km"), null));
  if (lower_km.TAG === /* Ok */0) {
    var upper_km = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "upper_km"), null));
    if (upper_km.TAG === /* Ok */0) {
      var price_per_km = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "price_per_km"), null));
      if (price_per_km.TAG === /* Ok */0) {
        var price_per_min = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "price_per_min"), null));
        if (price_per_min.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    lower_km: lower_km._0,
                    upper_km: upper_km._0,
                    price_per_km: price_per_km._0,
                    price_per_min: price_per_min._0
                  }
                };
        }
        var e = price_per_min._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".price_per_min" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = price_per_km._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".price_per_km" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = upper_km._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".upper_km" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = lower_km._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".lower_km" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function toll_breakup_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var amount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "amount"), null));
    if (amount.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                title: title._0,
                amount: amount._0
              }
            };
    }
    var e = amount._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".amount" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function fare_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var partner_trip_fare = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "partner_trip_fare"), null));
  if (partner_trip_fare.TAG === /* Ok */0) {
    var porter_bearing_total_discount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "porter_bearing_total_discount"), null));
    if (porter_bearing_total_discount.TAG === /* Ok */0) {
      var trip_fare = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trip_fare"), null));
      if (trip_fare.TAG === /* Ok */0) {
        var pre_trip_fare_round_off = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "pre_trip_fare_round_off"), null));
        if (pre_trip_fare_round_off.TAG === /* Ok */0) {
          var base_fare = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "base_fare"), null));
          if (base_fare.TAG === /* Ok */0) {
            var distance_charge = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "distance_charge"), null));
            if (distance_charge.TAG === /* Ok */0) {
              var travel_duration_charge = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "travel_duration_charge"), null));
              if (travel_duration_charge.TAG === /* Ok */0) {
                var waiting_charge = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "waiting_charge"), null));
                if (waiting_charge.TAG === /* Ok */0) {
                  var flat_surge_amount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "flat_surge_amount"), null));
                  if (flat_surge_amount.TAG === /* Ok */0) {
                    var waiting_time = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "waiting_time"), null));
                    if (waiting_time.TAG === /* Ok */0) {
                      var travel_distance = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "travel_distance"), null));
                      if (travel_distance.TAG === /* Ok */0) {
                        var travel_duration = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "travel_duration"), null));
                        if (travel_duration.TAG === /* Ok */0) {
                          var pickup_extra_charge = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pickup_extra_charge"), null));
                          if (pickup_extra_charge.TAG === /* Ok */0) {
                            var drop_extra_charge = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "drop_extra_charge"), null));
                            if (drop_extra_charge.TAG === /* Ok */0) {
                              var convenience_charge = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "convenience_charge"), null));
                              if (convenience_charge.TAG === /* Ok */0) {
                                var toll = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "toll"), null));
                                if (toll.TAG === /* Ok */0) {
                                  var road_tax = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "road_tax"), null));
                                  if (road_tax.TAG === /* Ok */0) {
                                    var environmental_tax = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "environmental_tax"), null));
                                    if (environmental_tax.TAG === /* Ok */0) {
                                      var toll_breakup_details = Decco.listFromJson(toll_breakup_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "toll_breakup_details"), null));
                                      if (toll_breakup_details.TAG === /* Ok */0) {
                                        var referral_discount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "referral_discount"), null));
                                        if (referral_discount.TAG === /* Ok */0) {
                                          var coupon_discount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "coupon_discount"), null));
                                          if (coupon_discount.TAG === /* Ok */0) {
                                            var subscription_discount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "subscription_discount"), null));
                                            if (subscription_discount.TAG === /* Ok */0) {
                                              var waypoints = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "waypoints"), null));
                                              if (waypoints.TAG === /* Ok */0) {
                                                var credit_charge = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "credit_charge"), null));
                                                if (credit_charge.TAG === /* Ok */0) {
                                                  var vat = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "vat"), null));
                                                  if (vat.TAG === /* Ok */0) {
                                                    var helper_charge = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "helper_charge"), null));
                                                    if (helper_charge.TAG === /* Ok */0) {
                                                      var helper_plus_labour_charge = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "helper_plus_labour_charge"), null));
                                                      if (helper_plus_labour_charge.TAG === /* Ok */0) {
                                                        var waypoint_charge = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "waypoint_charge"), null));
                                                        if (waypoint_charge.TAG === /* Ok */0) {
                                                          var tax_on_commission = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tax_on_commission"), null));
                                                          if (tax_on_commission.TAG === /* Ok */0) {
                                                            var cgst_on_commission = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cgst_on_commission"), null));
                                                            if (cgst_on_commission.TAG === /* Ok */0) {
                                                              var sgst_on_commission = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sgst_on_commission"), null));
                                                              if (sgst_on_commission.TAG === /* Ok */0) {
                                                                var igst_on_commission = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "igst_on_commission"), null));
                                                                if (igst_on_commission.TAG === /* Ok */0) {
                                                                  var loading_time = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "loading_time"), null));
                                                                  if (loading_time.TAG === /* Ok */0) {
                                                                    var unloading_time = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "unloading_time"), null));
                                                                    if (unloading_time.TAG === /* Ok */0) {
                                                                      var pod_charge = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pod_charge"), null));
                                                                      if (pod_charge.TAG === /* Ok */0) {
                                                                        var fare_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fare_type"), null));
                                                                        if (fare_type.TAG === /* Ok */0) {
                                                                          var fare_with_dues = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "fare_with_dues"), null));
                                                                          if (fare_with_dues.TAG === /* Ok */0) {
                                                                            var breakup_details = Decco.optionFromJson(breakup_details_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "breakup_details"), null));
                                                                            if (breakup_details.TAG === /* Ok */0) {
                                                                              var online_paid_amount_with_discount = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "online_paid_amount_with_discount"), null));
                                                                              if (online_paid_amount_with_discount.TAG === /* Ok */0) {
                                                                                var distance_time_pricing_info = Decco.optionFromJson((function (param) {
                                                                                        return Decco.listFromJson(pricing_decode, param);
                                                                                      }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "distance_time_pricing_info"), null));
                                                                                if (distance_time_pricing_info.TAG === /* Ok */0) {
                                                                                  var courier_fee = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "courier_fee"), null));
                                                                                  if (courier_fee.TAG === /* Ok */0) {
                                                                                    return {
                                                                                            TAG: /* Ok */0,
                                                                                            _0: {
                                                                                              partner_trip_fare: partner_trip_fare._0,
                                                                                              porter_bearing_total_discount: porter_bearing_total_discount._0,
                                                                                              trip_fare: trip_fare._0,
                                                                                              pre_trip_fare_round_off: pre_trip_fare_round_off._0,
                                                                                              base_fare: base_fare._0,
                                                                                              distance_charge: distance_charge._0,
                                                                                              travel_duration_charge: travel_duration_charge._0,
                                                                                              waiting_charge: waiting_charge._0,
                                                                                              flat_surge_amount: flat_surge_amount._0,
                                                                                              waiting_time: waiting_time._0,
                                                                                              travel_distance: travel_distance._0,
                                                                                              travel_duration: travel_duration._0,
                                                                                              pickup_extra_charge: pickup_extra_charge._0,
                                                                                              drop_extra_charge: drop_extra_charge._0,
                                                                                              convenience_charge: convenience_charge._0,
                                                                                              toll: toll._0,
                                                                                              road_tax: road_tax._0,
                                                                                              environmental_tax: environmental_tax._0,
                                                                                              toll_breakup_details: toll_breakup_details._0,
                                                                                              referral_discount: referral_discount._0,
                                                                                              coupon_discount: coupon_discount._0,
                                                                                              subscription_discount: subscription_discount._0,
                                                                                              waypoints: waypoints._0,
                                                                                              credit_charge: credit_charge._0,
                                                                                              vat: vat._0,
                                                                                              helper_charge: helper_charge._0,
                                                                                              helper_plus_labour_charge: helper_plus_labour_charge._0,
                                                                                              waypoint_charge: waypoint_charge._0,
                                                                                              tax_on_commission: tax_on_commission._0,
                                                                                              cgst_on_commission: cgst_on_commission._0,
                                                                                              sgst_on_commission: sgst_on_commission._0,
                                                                                              igst_on_commission: igst_on_commission._0,
                                                                                              loading_time: loading_time._0,
                                                                                              unloading_time: unloading_time._0,
                                                                                              pod_charge: pod_charge._0,
                                                                                              fare_type: fare_type._0,
                                                                                              fare_with_dues: fare_with_dues._0,
                                                                                              breakup_details: breakup_details._0,
                                                                                              online_paid_amount_with_discount: online_paid_amount_with_discount._0,
                                                                                              distance_time_pricing_info: distance_time_pricing_info._0,
                                                                                              courier_fee: courier_fee._0
                                                                                            }
                                                                                          };
                                                                                  }
                                                                                  var e = courier_fee._0;
                                                                                  return {
                                                                                          TAG: /* Error */1,
                                                                                          _0: {
                                                                                            path: ".courier_fee" + e.path,
                                                                                            message: e.message,
                                                                                            value: e.value
                                                                                          }
                                                                                        };
                                                                                }
                                                                                var e$1 = distance_time_pricing_info._0;
                                                                                return {
                                                                                        TAG: /* Error */1,
                                                                                        _0: {
                                                                                          path: ".distance_time_pricing_info" + e$1.path,
                                                                                          message: e$1.message,
                                                                                          value: e$1.value
                                                                                        }
                                                                                      };
                                                                              }
                                                                              var e$2 = online_paid_amount_with_discount._0;
                                                                              return {
                                                                                      TAG: /* Error */1,
                                                                                      _0: {
                                                                                        path: ".online_paid_amount_with_discount" + e$2.path,
                                                                                        message: e$2.message,
                                                                                        value: e$2.value
                                                                                      }
                                                                                    };
                                                                            }
                                                                            var e$3 = breakup_details._0;
                                                                            return {
                                                                                    TAG: /* Error */1,
                                                                                    _0: {
                                                                                      path: ".breakup_details" + e$3.path,
                                                                                      message: e$3.message,
                                                                                      value: e$3.value
                                                                                    }
                                                                                  };
                                                                          }
                                                                          var e$4 = fare_with_dues._0;
                                                                          return {
                                                                                  TAG: /* Error */1,
                                                                                  _0: {
                                                                                    path: ".fare_with_dues" + e$4.path,
                                                                                    message: e$4.message,
                                                                                    value: e$4.value
                                                                                  }
                                                                                };
                                                                        }
                                                                        var e$5 = fare_type._0;
                                                                        return {
                                                                                TAG: /* Error */1,
                                                                                _0: {
                                                                                  path: ".fare_type" + e$5.path,
                                                                                  message: e$5.message,
                                                                                  value: e$5.value
                                                                                }
                                                                              };
                                                                      }
                                                                      var e$6 = pod_charge._0;
                                                                      return {
                                                                              TAG: /* Error */1,
                                                                              _0: {
                                                                                path: ".pod_charge" + e$6.path,
                                                                                message: e$6.message,
                                                                                value: e$6.value
                                                                              }
                                                                            };
                                                                    }
                                                                    var e$7 = unloading_time._0;
                                                                    return {
                                                                            TAG: /* Error */1,
                                                                            _0: {
                                                                              path: ".unloading_time" + e$7.path,
                                                                              message: e$7.message,
                                                                              value: e$7.value
                                                                            }
                                                                          };
                                                                  }
                                                                  var e$8 = loading_time._0;
                                                                  return {
                                                                          TAG: /* Error */1,
                                                                          _0: {
                                                                            path: ".loading_time" + e$8.path,
                                                                            message: e$8.message,
                                                                            value: e$8.value
                                                                          }
                                                                        };
                                                                }
                                                                var e$9 = igst_on_commission._0;
                                                                return {
                                                                        TAG: /* Error */1,
                                                                        _0: {
                                                                          path: ".igst_on_commission" + e$9.path,
                                                                          message: e$9.message,
                                                                          value: e$9.value
                                                                        }
                                                                      };
                                                              }
                                                              var e$10 = sgst_on_commission._0;
                                                              return {
                                                                      TAG: /* Error */1,
                                                                      _0: {
                                                                        path: ".sgst_on_commission" + e$10.path,
                                                                        message: e$10.message,
                                                                        value: e$10.value
                                                                      }
                                                                    };
                                                            }
                                                            var e$11 = cgst_on_commission._0;
                                                            return {
                                                                    TAG: /* Error */1,
                                                                    _0: {
                                                                      path: ".cgst_on_commission" + e$11.path,
                                                                      message: e$11.message,
                                                                      value: e$11.value
                                                                    }
                                                                  };
                                                          }
                                                          var e$12 = tax_on_commission._0;
                                                          return {
                                                                  TAG: /* Error */1,
                                                                  _0: {
                                                                    path: ".tax_on_commission" + e$12.path,
                                                                    message: e$12.message,
                                                                    value: e$12.value
                                                                  }
                                                                };
                                                        }
                                                        var e$13 = waypoint_charge._0;
                                                        return {
                                                                TAG: /* Error */1,
                                                                _0: {
                                                                  path: ".waypoint_charge" + e$13.path,
                                                                  message: e$13.message,
                                                                  value: e$13.value
                                                                }
                                                              };
                                                      }
                                                      var e$14 = helper_plus_labour_charge._0;
                                                      return {
                                                              TAG: /* Error */1,
                                                              _0: {
                                                                path: ".helper_plus_labour_charge" + e$14.path,
                                                                message: e$14.message,
                                                                value: e$14.value
                                                              }
                                                            };
                                                    }
                                                    var e$15 = helper_charge._0;
                                                    return {
                                                            TAG: /* Error */1,
                                                            _0: {
                                                              path: ".helper_charge" + e$15.path,
                                                              message: e$15.message,
                                                              value: e$15.value
                                                            }
                                                          };
                                                  }
                                                  var e$16 = vat._0;
                                                  return {
                                                          TAG: /* Error */1,
                                                          _0: {
                                                            path: ".vat" + e$16.path,
                                                            message: e$16.message,
                                                            value: e$16.value
                                                          }
                                                        };
                                                }
                                                var e$17 = credit_charge._0;
                                                return {
                                                        TAG: /* Error */1,
                                                        _0: {
                                                          path: ".credit_charge" + e$17.path,
                                                          message: e$17.message,
                                                          value: e$17.value
                                                        }
                                                      };
                                              }
                                              var e$18 = waypoints._0;
                                              return {
                                                      TAG: /* Error */1,
                                                      _0: {
                                                        path: ".waypoints" + e$18.path,
                                                        message: e$18.message,
                                                        value: e$18.value
                                                      }
                                                    };
                                            }
                                            var e$19 = subscription_discount._0;
                                            return {
                                                    TAG: /* Error */1,
                                                    _0: {
                                                      path: ".subscription_discount" + e$19.path,
                                                      message: e$19.message,
                                                      value: e$19.value
                                                    }
                                                  };
                                          }
                                          var e$20 = coupon_discount._0;
                                          return {
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    path: ".coupon_discount" + e$20.path,
                                                    message: e$20.message,
                                                    value: e$20.value
                                                  }
                                                };
                                        }
                                        var e$21 = referral_discount._0;
                                        return {
                                                TAG: /* Error */1,
                                                _0: {
                                                  path: ".referral_discount" + e$21.path,
                                                  message: e$21.message,
                                                  value: e$21.value
                                                }
                                              };
                                      }
                                      var e$22 = toll_breakup_details._0;
                                      return {
                                              TAG: /* Error */1,
                                              _0: {
                                                path: ".toll_breakup_details" + e$22.path,
                                                message: e$22.message,
                                                value: e$22.value
                                              }
                                            };
                                    }
                                    var e$23 = environmental_tax._0;
                                    return {
                                            TAG: /* Error */1,
                                            _0: {
                                              path: ".environmental_tax" + e$23.path,
                                              message: e$23.message,
                                              value: e$23.value
                                            }
                                          };
                                  }
                                  var e$24 = road_tax._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".road_tax" + e$24.path,
                                            message: e$24.message,
                                            value: e$24.value
                                          }
                                        };
                                }
                                var e$25 = toll._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".toll" + e$25.path,
                                          message: e$25.message,
                                          value: e$25.value
                                        }
                                      };
                              }
                              var e$26 = convenience_charge._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".convenience_charge" + e$26.path,
                                        message: e$26.message,
                                        value: e$26.value
                                      }
                                    };
                            }
                            var e$27 = drop_extra_charge._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".drop_extra_charge" + e$27.path,
                                      message: e$27.message,
                                      value: e$27.value
                                    }
                                  };
                          }
                          var e$28 = pickup_extra_charge._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".pickup_extra_charge" + e$28.path,
                                    message: e$28.message,
                                    value: e$28.value
                                  }
                                };
                        }
                        var e$29 = travel_duration._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".travel_duration" + e$29.path,
                                  message: e$29.message,
                                  value: e$29.value
                                }
                              };
                      }
                      var e$30 = travel_distance._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".travel_distance" + e$30.path,
                                message: e$30.message,
                                value: e$30.value
                              }
                            };
                    }
                    var e$31 = waiting_time._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".waiting_time" + e$31.path,
                              message: e$31.message,
                              value: e$31.value
                            }
                          };
                  }
                  var e$32 = flat_surge_amount._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".flat_surge_amount" + e$32.path,
                            message: e$32.message,
                            value: e$32.value
                          }
                        };
                }
                var e$33 = waiting_charge._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".waiting_charge" + e$33.path,
                          message: e$33.message,
                          value: e$33.value
                        }
                      };
              }
              var e$34 = travel_duration_charge._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".travel_duration_charge" + e$34.path,
                        message: e$34.message,
                        value: e$34.value
                      }
                    };
            }
            var e$35 = distance_charge._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".distance_charge" + e$35.path,
                      message: e$35.message,
                      value: e$35.value
                    }
                  };
          }
          var e$36 = base_fare._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".base_fare" + e$36.path,
                    message: e$36.message,
                    value: e$36.value
                  }
                };
        }
        var e$37 = pre_trip_fare_round_off._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".pre_trip_fare_round_off" + e$37.path,
                  message: e$37.message,
                  value: e$37.value
                }
              };
      }
      var e$38 = trip_fare._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".trip_fare" + e$38.path,
                message: e$38.message,
                value: e$38.value
              }
            };
    }
    var e$39 = porter_bearing_total_discount._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".porter_bearing_total_discount" + e$39.path,
              message: e$39.message,
              value: e$39.value
            }
          };
  }
  var e$40 = partner_trip_fare._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".partner_trip_fare" + e$40.path,
            message: e$40.message,
            value: e$40.value
          }
        };
}

function order_fares_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var vendor = Decco.optionFromJson(fare_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "vendor"), null));
  if (vendor.TAG === /* Ok */0) {
    var customer = Decco.optionFromJson(fare_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "customer"), null));
    if (customer.TAG === /* Ok */0) {
      var fixed_fallback = Decco.optionFromJson(fare_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "fixed_fallback"), null));
      if (fixed_fallback.TAG === /* Ok */0) {
        var estimated = fare_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "estimated"), null));
        if (estimated.TAG === /* Ok */0) {
          var $$default = Decco.optionFromJson(fare_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "default"), null));
          if ($$default.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      vendor: vendor._0,
                      customer: customer._0,
                      fixed_fallback: fixed_fallback._0,
                      estimated: estimated._0,
                      default: $$default._0
                    }
                  };
          }
          var e = $$default._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".default" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = estimated._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".estimated" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = fixed_fallback._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".fixed_fallback" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = customer._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".customer" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = vendor._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".vendor" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var order_fares = order_fares_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "order_fares"), null));
  if (order_fares.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              order_fares: order_fares._0
            }
          };
  }
  var e = order_fares._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".order_fares" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  amount_decode ,
  online_payment_breakup_decode ,
  online_payment_details_decode ,
  breakup_details_decode ,
  pricing_decode ,
  toll_breakup_decode ,
  fare_decode ,
  order_fares_decode ,
  t_decode ,
  
}
/* No side effect */
